export default "__VITE_ASSET__DaQHS4D5__"